const DOMAIN = process.env.VUE_APP_API_URL;

const BASE = `${DOMAIN}/api/roadhk`;

export const TD = `${BASE}/td`;
export const TD_NEWS = `${TD}/news/data-gov`;

export const ROUTE = `${BASE}/route`;
export const ROUTE_SUGGEST = `${ROUTE}/suggest`;
export const ROUTE_DETAILS = `${ROUTE}`;
export const ROUTE_STOP_DETAILS = `${ROUTE}/stop`;
export const ROUTE_LINE = `${ROUTE}/route-line`;

export const STOP = `${BASE}/stop`;
export const STOP_DETAILS = `${STOP}`;
export const STOP_GROUP = `${STOP}/stop-group`;
export const STOP_SUGGEST = `${BASE}/stop/suggest`;

export const NEARBY = `${BASE}/nearby`;
export const NEARBY_ROUTE = `${NEARBY}/routes`;
export const NEARBY_STOP = `${NEARBY}/stops`;
export const NEARBY_STOP_BY_ROUTE = `${NEARBY}/by-route`;

export const P2P = `${BASE}/p2p`;
export const P2P_DETAIL = `${P2P}/detail`;

export function queryStringBuilder(params) {
  return Object.keys(params)
    .filter(x => {
      return params[x] !== "" && params[x] !== undefined && params[x] !== undefined
    })
    .map(x => `${x}=${params[x]}`)
    .join('&');
}
